import { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AboutBuloke() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    axios.get(`${API}/about-buloke-settings`)
      .then(res => setSettings(res.data))
      .catch(console.error);
  }, []);

  if (!settings) return null;

  const align = settings.alignment || 'left';
  const textAlign = align === 'center' ? 'text-center' : align === 'right' ? 'text-right' : 'text-left';
  const btnAlign = align === 'center' ? 'justify-center' : align === 'right' ? 'justify-end' : 'justify-start';

  return (
    <section className="py-10 bg-white" data-testid="about-buloke-section">
      <div className="container mx-auto px-4">
        <div className={`max-w-4xl ${align === 'center' ? 'mx-auto' : ''}`}>
          <h2 className={`text-3xl sm:text-4xl lg:text-5xl font-bold text-[#222] mb-4 ${textAlign}`}>
            {settings.headline}
          </h2>
          <div className={`flex ${btnAlign} mb-6`}>
            <div className="w-24 h-1 bg-[#E12429]"></div>
          </div>
          <p className={`text-base sm:text-lg text-[#666] leading-relaxed mb-8 ${textAlign}`}>
            {settings.content}
          </p>
          {settings.button_text && settings.button_link && (
            <div className={`flex ${btnAlign}`}>
              <a
                href={settings.button_link}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-[#E12429] hover:bg-[#c41f23] text-white font-semibold px-8 py-3.5 rounded transition-colors"
                data-testid="learn-more-buloke-btn"
              >
                {settings.button_text}
                <ArrowRight size={18} />
              </a>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
